import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Header from '../../../common/Header';
import TicketBanner from '../../../common/TicketBanner';


function BusTicketBanner() {
  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Bus ticket" />
        {/* CARDS */}
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <Link to={"/ticket/bus/tickets"} className="breadcrumb-item active" aria-current="page">
                Bus Ticket
                </Link>
                <Link to={"/ticket/bus/routes"} className="breadcrumb-item active" aria-current="page">
                Routes
                </Link>
                <li className="breadcrumb-item active" aria-current="page">
                carousel
                </li>
              </ol>
            </nav>
            <hr />
              <TicketBanner type={"bus"}/>
       
          </div>
        </div>
      </div>
    </>
  )
}

export default BusTicketBanner